import * as React from "react"
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#4F2E03"
      d="M12.758.251H.742A.743.743 0 0 0 0 .993v12.015a.742.742 0 0 0 .743.743h6.466V8.52H5.454V6.495h1.755V4.976a2.457 2.457 0 0 1 2.619-2.7c.525-.003 1.05.024 1.573.081v1.822h-1.073c-.851 0-1.013.405-1.013.993v1.302h2.025L11.077 8.5H9.315v5.252h3.443a.742.742 0 0 0 .742-.742V.992a.743.743 0 0 0-.742-.742Z"
    />
  </svg>
)
export default SvgComponent